// @flow

export const DATE_TYPES = {
  DATE_RANGE: "dateRange",
  ANYTIME: "anytime",
  TIME_TO_STAY: "timeToStay",
  NO_RETURN: "noReturn",
}

export type DateTypes = $Values<typeof DATE_TYPES>

export type Common = { isDefault: boolean }

export type DateRange = Common & {
  type: "dateRange",
  from: Date,
  to: Date,
}

export type TimeToStay = Common & {
  type: "timeToStay",
  min: number,
  max: number,
}

export type Anytime = Common & {
  type: "anytime",
}

export type NoReturn = Common & {
  type: "noReturn",
}

export type SearchDate = DateRange | TimeToStay | Anytime | NoReturn
